import React from 'react';
import { MOBILE_NAV_INACTIVE_COLOR } from '../navigationColors';

/**
 * Earth / Impact nav icon. Pass `color`; defaults to the shared mobile-nav idle color.
 */
export default function EarthNavIconSvg({
  width = 24,
  height = 24,
  color = MOBILE_NAV_INACTIVE_COLOR,
  ...rest
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      style={{ color }}
      {...rest}
    >
      <path
        d="M21.54 15H17C16.4696 15 15.9609 15.2107 15.5858 15.5858C15.2107 15.9609 15 16.4696 15 17V21.54"
        stroke="currentColor"
        strokeWidth="1.07143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 3.33984V4.99984C7 5.79549 7.31607 6.55855 7.87868 7.12116C8.44129 7.68377 9.20435 7.99984 10 7.99984C10.5304 7.99984 11.0391 8.21056 11.4142 8.58563C11.7893 8.9607 12 9.46941 12 9.99984C12 11.0998 12.9 11.9998 14 11.9998C14.5304 11.9998 15.0391 11.7891 15.4142 11.4141C15.7893 11.039 16 10.5303 16 9.99984C16 8.89984 16.9 7.99984 18 7.99984H21.17"
        stroke="currentColor"
        strokeWidth="1.07143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 21.95V18C11 17.4696 10.7893 16.9609 10.4143 16.5858C10.0392 16.2107 9.53048 16 9.00005 16C8.46962 16 7.96091 15.7893 7.58584 15.4142C7.21076 15.0391 7.00005 14.5304 7.00005 14V13C7.00005 12.4696 6.78934 11.9609 6.41426 11.5858C6.03919 11.2107 5.53048 11 5.00005 11H2.05005"
        stroke="currentColor"
        strokeWidth="1.07143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="currentColor"
        strokeWidth="1.07143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
